import React from "react";

const CommonStatCard = (props) => {
  const {
    tagName,
    cardLabel,
    value,
    icon,
    onClickCard,
    classname,
    trend,
    valueIcon,
  } = props || {};

  return (
    <div
      className={`pt-flow-new-stat-card-container ${!icon ? "no-icon" : ""} ${
        classname || ""
      }`}
      onClick={() =>
        onClickCard &&
        (tagName === "home" || tagName === "lms"
          ? onClickCard()
          : onClickCard(tagName))
      }
      style={{
        cursor: onClickCard ? "pointer" : "not-allowed",
      }}
    >
      {icon && (
        <div className="card-top">
          <div className="card-top-icon">{icon}</div>
          <div className="card-top-label"></div>
        </div>
      )}

      <div className="card-mid">
        <p className="card-mid-label">{cardLabel}</p>
      </div>

      <div className="card-bottom">
        <p className="card-mid-value">{value}</p>

        {valueIcon && <div className="card-value-icon">{valueIcon}</div>}
      </div>

      {trend ? (
        <div className={`card-bottom-graph ${trend ? `trend-${trend}` : ""}`}>
          <svg
            width="100%"
            height="20"
            viewBox="0 0 100 20"
            preserveAspectRatio="none"
          >
            <path
              d={
                trend === "up"
                  ? "M0,15 L20,10 L40,8 L60,6 L80,4 L100,2"
                  : trend === "down"
                  ? "M0,5 L20,8 L40,10 L60,12 L80,14 L100,16"
                  : "M0,10 L20,10 L40,10 L60,10 L80,10 L100,10"
              }
              stroke={
                trend === "up"
                  ? "#3B82F6"
                  : trend === "down"
                  ? "#EF4444"
                  : "#9CA3AF"
              }
              strokeWidth="2"
              fill="none"
            />
            {trend === "up" && (
              <path
                d="M0,15 L20,10 L40,8 L60,6 L80,4 L100,2 L100,20 L0,20 Z"
                fill="#3B82F6"
                fillOpacity="0.1"
              />
            )}
            {trend === "down" && (
              <path
                d="M0,5 L20,8 L40,10 L60,12 L80,14 L100,16 L100,20 L0,20 Z"
                fill="#EF4444"
                fillOpacity="0.1"
              />
            )}
          </svg>
        </div>
      ) : null}
    </div>
  );
};

export default CommonStatCard;
